(function () {
  'use strict';

  function redirectToThankYou(url, email) {
    var target = url || '/pages/free-truck-maintenance-manual-thank-you';
    if (email) {
      try {
        sessionStorage.setItem('lp_subscriber_email', email);
      } catch (error) {
      }
    }
    window.location.href = target;
  }

  function setStatus(form, message, isError) {
    var status = form.parentNode.querySelector('[data-form-status]');
    if (!status) {
      return;
    }

    status.textContent = message;
    status.classList.add('is-visible');
    status.classList.toggle('is-error', !!isError);
  }

  function bindCaptureForms() {
    if (window.__lpCaptureInit) {
      return;
    }

    window.__lpCaptureInit = true;

    document.querySelectorAll('[data-lp-capture]').forEach(function (form) {
      if (form.dataset.lpBound) {
        return;
      }

      form.dataset.lpBound = 'true';

      form.addEventListener('submit', function (event) {
        var emailInput = form.querySelector('input[type="email"]');
        var email = emailInput ? emailInput.value.trim() : '';
        var companyId = form.getAttribute('data-company-id');
        var listId = form.getAttribute('data-list-id');
        var thankYouUrl = form.getAttribute('data-thank-you-url');
        var source = form.getAttribute('data-source') || 'lp-landing-page';
        var honeypot = form.querySelector('input[name="company_website"]');

        if (!emailInput || !emailInput.checkValidity()) {
          event.preventDefault();
          setStatus(form, 'Please enter a valid email address.', true);
          if (emailInput) {
            emailInput.focus();
          }
          return;
        }

        if (honeypot && honeypot.value) {
          event.preventDefault();
          redirectToThankYou(thankYouUrl, email);
          return;
        }

        if (!companyId || !listId) {
          event.preventDefault();
          redirectToThankYou(thankYouUrl, email);
          return;
        }

        event.preventDefault();
        setStatus(form, 'Saving your email and preparing your manual...', false);

        var payload = {
          data: {
            type: 'subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                    properties: {
                      optin_source: source,
                      lead_captured: true
                    },
                    subscriptions: {
                      email: {
                        marketing: {
                          consent: 'SUBSCRIBED'
                        }
                      }
                    }
                  }
                }
              }
            },
            relationships: {
              list: {
                data: {
                  type: 'list',
                  id: listId
                }
              }
            }
          }
        };

        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/vnd.api+json',
            'revision': '2026-04-15'
          },
          body: JSON.stringify(payload)
        })
          .then(function (response) {
            if (!response.ok && response.status !== 202) {
              throw new Error('subscription_failed');
            }
            redirectToThankYou(thankYouUrl, email);
          })
          .catch(function () {
            setStatus(form, 'Something went wrong. Please try again, or refresh the page.', true);
          });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindCaptureForms);
  } else {
    bindCaptureForms();
  }
})();
